/** Backend `LEDGER_SOURCE_TYPE` — journal/ledger filters share this list. */
export const LEDGER_SOURCE_TYPES = [
  "INVOICE",
  "PAYMENT",
  "RETURN",
  "DELIVERY",
  "MANUAL",
  "REVERSAL",
  "ADJUSTMENT",
  "INBOUND",
  "DAMAGE",
  "OPENING",
  "YEAR_END_CLOSE",
  "CONSIGNMENT",
  "RESALE",
  "INVOICE_AMENDMENT",
] as const;

export type LedgerSourceType = (typeof LEDGER_SOURCE_TYPES)[number];

/** i18n key fragment for `billing:ledger.template.*` (dots → underscores). */
export function postingTemplateI18nKey(code: string): string {
  return code.replace(/\./g, "_");
}
